import { LoadMore } from '@tbitop/mobile-app';
import { LoadingSpinner, Paragraph } from '@tbitop/ui';
import type { Pagination } from '../../../core/application/pagination';
import { ObjektListItemAktionAnlegen } from './objekt-list-item-aktion-erstellen';
import type { Objekt } from './objekt-list-types';

type ObjektListAktionAnlegenProps = {
  loading: boolean;
  objekte: Objekt[];
  onDirektAbschliessen: (aufgabenId: string, onDirektAbschliessen: () => void) => void;
  pagination: Pagination;
  aufgabenId: string;
};

export const ObjektListAktionAnlegen = ({ aufgabenId, loading, objekte, pagination, onDirektAbschliessen }: ObjektListAktionAnlegenProps) => {

  return <>
    {loading ? (
      <div className="flex items-center justify-center my-48">
        <LoadingSpinner />
      </div>
    ) : null}
    <ObjektList objekte={objekte} pagination={pagination} pageLoading={loading} aufgabenId={aufgabenId} onDirektAbschliessen={onDirektAbschliessen}/>
    {!loading && objekte.length === 0 &&
      <Paragraph className="text-center text-tds-color-copy-on-light-10">
          Keine Daten verfügbar
      </Paragraph>}
  </>;
};

type ObjektListProps = {
  objekte: Objekt[];
  pagination: Pagination;
  aufgabenId: string;
  pageLoading?: boolean;
  onDirektAbschliessen: (aufgabenId: string, onDirektAbschliessen: () => void) => void;
};

export const ObjektList = ({ objekte, pagination, aufgabenId, onDirektAbschliessen, pageLoading }: ObjektListProps) => {

  return <div>
    <div role="rowgroup" className="flex flex-col gap-100">
      {objekte.map(objekt => (
        <ObjektListItemAktionAnlegen objekt={objekt} aufgabenId={aufgabenId} key={objekt.id} onDirektAbschliessen={onDirektAbschliessen} />
      ))}
    </div>
    {!pageLoading && !!pagination && <LoadMore hasMore={pagination.hasMore} onLoadMore={() => pagination.fetchMore()} />}
  </div>;
};
